import { render } from "./TransferReport.vue?vue&type=template&id=1aa38aa6&ts=true"
import script from "./TransferReport.vue?vue&type=script&lang=ts"
export * from "./TransferReport.vue?vue&type=script&lang=ts"

import exportComponent from "/var/www/html/myittar_pharmacy_pos/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__